import { isAaaGameInformationAvailabilityFormValid } from "../../../../helpers/formValidation";
import {
  AaaGameInformationAvailabilityDataType,
  SubFormsDataTypes,
} from "../../../../models/forms";
import { DataFilterResult, IDataFilter } from "../dataFilter";

export const AaaAvailabilityDataFilter: IDataFilter = {
  validate: async (data: SubFormsDataTypes | undefined): Promise<DataFilterResult> => {
    const pricingData = data as AaaGameInformationAvailabilityDataType;
    if (!pricingData) {
      return { result: true };
    }

    const validSchema = await isAaaGameInformationAvailabilityFormValid(pricingData);
    return { result: validSchema };
  },
};
